export class GetSettingResult {
    badgeList = [];
    mypageTableSetting = new MypageTableSetting();
    informationTermsOfUseVersion = "";
    menuInfo = [];
    topPageMenuInfo = [];
    displayInfo = [];
    menubarLinkInfo = [];
}
export class MypageTableSetting {
    initValue = -1;
    rowPerPageOptions = [];
}
export class RowPerPageOptions {
    label = "";
    value = -1;
}
